import StaffTable from './StaffTable';

export { StaffTable };

export default StaffTable;
